import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2, ShieldCheck } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { adminLogin, apiErr } from "@/lib/api";

export default function AdminLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (localStorage.getItem("admin_token")) nav("/admin/dashboard", { replace: true });
    }, [nav]);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const res = await adminLogin({ email, password });
            localStorage.setItem("admin_token", res.token);
            localStorage.setItem("admin_user", JSON.stringify(res.user));
            toast.success("Welcome back.");
            nav("/admin/dashboard", { replace: true });
        } catch (err) {
            toast.error(apiErr(err, "Invalid email or password"));
        } finally {
            setLoading(false);
        }
    };

    const inputCls =
        "mt-2 h-12 border-white/10 bg-white/5 text-white placeholder:text-white/30 focus-visible:ring-gold-300/40 focus-visible:border-gold-300/50";

    return (
        <div data-testid="admin-login-page" className="flex min-h-screen items-center justify-center px-6">
            <div className="w-full max-w-md">
                <div className="mb-8 text-center">
                    <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full glass glow-border text-gold-300">
                        <Lock size={22} />
                    </div>
                    <h1 className="mt-6 font-display text-3xl font-semibold">
                        Abhijit <span className="gold-text">JK</span> Admin
                    </h1>
                    <p className="mt-2 text-sm text-white/55">Sign in to view client submissions.</p>
                </div>
                <form onSubmit={submit} className="glass glow-border rounded-lg p-8">
                    <div>
                        <Label className="text-xs uppercase tracking-[0.2em] text-white/55">Email</Label>
                        <Input type="email" data-testid="admin-email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@abhijit.pro" className={inputCls} required />
                    </div>
                    <div className="mt-5">
                        <Label className="text-xs uppercase tracking-[0.2em] text-white/55">Password</Label>
                        <Input type="password" data-testid="admin-password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className={inputCls} required />
                    </div>
                    <button type="submit" disabled={loading} data-testid="admin-login-submit" className="gold-button mt-8 inline-flex w-full items-center justify-center gap-2 disabled:opacity-50">
                        {loading ? <Loader2 className="animate-spin" size={14} /> : <ShieldCheck size={14} />} Sign In
                    </button>
                </form>
            </div>
        </div>
    );
}
